import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import VendorFormLayer from "../components/VendorFormLayer";

const VendorFormPage = () => {
    return (
        <MasterLayout>
            <VendorFormLayer />
        </MasterLayout>
    );
};

export default VendorFormPage;
